import {Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {RoundOfQuestionsService} from '../../../services/round-of-questions.service';
import {KfReportingService} from '../../../../kf-reporting/services/kf-reporting.service';
import {appConfig} from '../../../../config/config';
import {QuestionsService} from '../../../services/questions.service';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {Questions} from '../../../models/questions.interface';
import {RoundOfQuestions} from '../../../models/round-of-questions.interface';
import {MatTable} from '@angular/material/table';
import {Master} from '../../../../admin/models/master.interface';
import {MatOptionSelectionChange} from '@angular/material/core';
import {forkJoin, Observable} from 'rxjs';
import {Page} from '../../../../shared/models/page.interface';
import {RoundOfQuestionsDetail} from '../../../models/round-of-questions-detail.interface';
import {KeyValue} from '@angular/common';
import {MatStepper} from '@angular/material/stepper';
import {LaunchRoundOfQuestionsComponent} from '../launch-round-of-questions/launch-round-of-questions.component';

@Component({
  selector: 'app-create-round-of-questions',
  templateUrl: './create-round-of-questions.component.html',
  styleUrls: ['./create-round-of-questions.component.scss']
})
export class CreateRoundOfQuestionsComponent implements OnInit {

  // categories
  categories!: Master[];
  categorySelectMap: Map<Master, number> = new Map<Master, number>();
  allCategoriesSelectedWithOrder = false;
  categoriesChecked: boolean[] = [];
  pageSizes = appConfig.pageSizes;
  displayedColumnsCategories: string[] = ['description', 'edit', 'order'];

  // questions
  questions: any = [];
  questionsCopy: any = [];
  questionsSelectMap: Map<Questions, number>[] = [];
  allQuestionsSelectedWithOrder = false;
  questionsChecked: any = [];
  displayedColumnsQuestions: string[] = ['questions.shortCode', 'questions.description', 'questions.questionType', 'edit', 'order'];

  summary = false;
  displayedColumnsSummary: string[] = ['questions.shortCode', 'questions.description', 'questions.questionType'];
  questionsText = 'This is the set of questions that WEEE Forum has provided:';
  years!: number[];
  launched!: string;
  dataSet = false;
  registrationLevel = '';

  roundOfQuestionsCreateForm = this.formBuilder.group({
    year: [0, Validators.required],
    name: ['', Validators.required],
    select: [0]
  });

  get yearControl(): FormControl {
    return this.roundOfQuestionsCreateForm.get('year') as FormControl;
  }

  get nameControl(): FormControl {
    return this.roundOfQuestionsCreateForm.get('name') as FormControl;
  }

  get selectControl(): FormControl {
    return this.roundOfQuestionsCreateForm.get('select') as FormControl;
  }

  roqTypeForm = this.formBuilder.group({
    type: ['', Validators.required]
  });

  get typeControl(): FormControl {
    return this.roqTypeForm.get('type') as FormControl;
  }

  registrationLevelFilter = this.formBuilder.group({
    level: []
  });

  get levelControl(): FormControl {
    return this.registrationLevelFilter.get('level') as FormControl;
  }

  totalElements!: number;
  pageSize = 100;

  @Output()
  createEvent: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('summaryTable')
  table!: MatTable<any>;

  @ViewChild(MatStepper)
  stepper!: MatStepper;

  constructor(private dialogRef: MatDialogRef<CreateRoundOfQuestionsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { copy: boolean, roundOfQuestions: RoundOfQuestions },
              private readonly formBuilder: FormBuilder,
              private readonly roundOfQuestionsService: RoundOfQuestionsService,
              private readonly kfReportingService: KfReportingService,
              private readonly questionsService: QuestionsService,
              private readonly dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.questionsService.getAllQuestionCategories('', {page: 0, size: 1000, sort: 'id', direction: 'asc'}).subscribe(
      data => {
        this.categories = data.content;
        data.content.forEach(() => {
          this.categoriesChecked.push(false);
        });
      }
    );
    this.kfReportingService.getAllYears().subscribe(
      data => {
        this.years = data;
        let currentYear = new Date().getFullYear();
        if (!data.includes(currentYear)) {
          while (data[0] < currentYear) {
            data.unshift(data[0] + 1);
          }
        }
      }
    );

    if (this.data.copy) {
      this.typeControl.setValue(this.data.roundOfQuestions.questionsType);
      this.levelControl.setValue(this.typeControl.value);
      this.roundOfQuestionsService.getAllDetail(
        this.data.roundOfQuestions.id,
        {page: 0, size: 1000, sort: 'id', direction: 'asc'}).subscribe(
        data => {
          this.questionsCopy = data.content;

          let i = 1;
          data.content.forEach((roqd) => {
            const categoryIndex = this.categories.findIndex(cat => cat.id === roqd.questions?.category.id as number);
            if (!this.categoriesChecked[categoryIndex]) {
              this.categoriesChecked[categoryIndex] = !this.categoriesChecked[categoryIndex];
              this.categorySelectMap.set(this.categories[categoryIndex], i);
              i++;
            }
          });
          setTimeout(() => {
            this.stepper.next();
            this.questionsStep();
            this.stepper.next();
          }, 120);

        }
      );
      this.yearControl.setValue(this.data.roundOfQuestions.year);
      this.nameControl.setValue('Copy of ' + this.data.roundOfQuestions.name);
    } else {
      const currentDate = new Date();
      this.yearControl.setValue(currentDate.getFullYear());
    }
  }

  // step 1
  categoriesStep(): void {
    this.levelControl.setValue(this.typeControl.value);
    this.filterCategories(this.levelControl.value);
  }

  // step 2

  setCategoryChecked(index: number): boolean {
    return this.categoriesChecked[index];
  }

  categoryCheckedChange(event: MatCheckboxChange, index: number): void {
    this.categoriesChecked[index] = !this.categoriesChecked[index];
    if (this.categoriesChecked[index]) {
      this.categorySelectMap.set(this.categories[index], 0);
    } else {
      this.categorySelectMap.delete(this.categories[index]);
    }
  }

  categorySelectChange(event: MatOptionSelectionChange, category: Master): void {
    if (event.isUserInput) {
      this.categorySelectMap.set(category, event.source.value);
    }

    this.allCategoriesSelectedWithOrder = !Array.from(this.categorySelectMap.values()).includes(0) &&
      [...new Set(Array.from(this.categorySelectMap.values()).map(value => value))].length === Array.from(this.categorySelectMap).length;
  }

  questionsStep(): void {
    const questions: Observable<Page<Questions>>[] = [];
    this.questionsSelectMap = [];
    for (let i = 1; i <= this.categorySelectMap.size; i++) {
      for (const [key, value] of this.categorySelectMap) {
        if (value === i) {
          questions.push(
            this.questionsService.getAllQuestions(
              {category: key.id, status: 'ACTIVE', level: this.levelControl.value},
              {page: 0, size: 1000, sort: 'shortCode', direction: 'asc'})
          );
          break;
        }
      }
    }

    forkJoin(questions).subscribe(
      data => {
        data.forEach(page => {
          this.questions.push(page.content);
          const checked: boolean[] = [];
          page.content.forEach(() => {
            checked.push(false);
          });
          if (page.content.length > 0) {
            this.questionsSelectMap.push(new Map<Questions, number>());
          }
          this.questionsChecked.push(checked);
        });

        if (this.data.copy && !this.dataSet) {
          let countQuestions = 0;
          let countQuestionsCopy = 0;
          this.questions.forEach((questionsPerCategory: any, index: number) => {
            let i = 1;
            countQuestionsCopy = 0;
            questionsPerCategory.forEach((q: Questions, index2: number) => {
              let questionIndex = this.questionsCopy.findIndex((roqd: any) => roqd.questions.id === q.id);
              if (index > 0) {
                questionIndex -= countQuestions;
              }
              if (questionIndex >= 0 && !this.questionsChecked[index][index2]) {
                this.questionsChecked[index][index2] = !this.questionsChecked[index][index2];
                this.questionsSelectMap[index].set(q, questionIndex + 1);
                i++;
                countQuestionsCopy++;
              }
            });
            countQuestions += countQuestionsCopy;
          });
          this.dataSet = true;
        }
      }
    );
  }

  // step 3

  setQuestionChecked(categoryIndex: number, questionIndex: number): boolean {
    return this.questionsChecked[categoryIndex][questionIndex];
  }

  questionsCheckedChange(event: MatCheckboxChange, categoryIndex: number, questionIndex: number): void {
    this.questionsChecked[categoryIndex][questionIndex] = !this.questionsChecked[categoryIndex][questionIndex];
    if (this.questionsChecked[categoryIndex][questionIndex]) {
      this.questionsSelectMap[categoryIndex].set(this.questions[categoryIndex][questionIndex], 0);
    } else {
      this.questionsSelectMap[categoryIndex].delete(this.questions[categoryIndex][questionIndex]);
    }
  }

  questionSelectChange(event: MatOptionSelectionChange, categoryIndex: number, question: Questions): void {
    if (event.isUserInput) {
      this.questionsSelectMap[categoryIndex].set(question, event.source.value);
    }

    for (const questions of this.questionsSelectMap) {
      if (!Array.from(questions.values()).includes(0) &&
        [...new Set(Array.from(questions.values()).map((value => value)))].length === Array.from(questions).length) {
        this.allQuestionsSelectedWithOrder = true;
      } else {
        this.allQuestionsSelectedWithOrder = false;
        break;
      }
    }
  }

  resetQuestions(): void {
    this.questions = [];
    this.allQuestionsSelectedWithOrder = false;
    this.questionsChecked = [];
  }

  summaryStep(): void {
    this.table?.renderRows();
    this.summary = true;
  }


  launch(): void {
    const dialogRef = this.dialog.open(LaunchRoundOfQuestionsComponent, {maxWidth: 600, width: 'inherit'});

    dialogRef.componentInstance.confirmWithNotificationEventEvent.subscribe(() => {
      this.launched = new Date().toISOString();

      let system = false;
      let country = false;
      this.questionsSelectMap.forEach(map => {
        map.forEach((value, key) => {
          if (key.questionType === 'BOTH') {
            system = true;
            country = true;
          } else {
            if (key.questionType === 'SYSTEM') {
              system = true;
            }
            if (key.questionType === 'COUNTRY') {
              country = true;
            }
          }
        });
      });
      this.sendCreationRequest(system, country);
    });

    dialogRef.componentInstance.confirmEvent.subscribe(() => {
      this.launched = new Date().toISOString();
      this.sendCreationRequest();
    });

  }

  sendCreationRequest(system: boolean = false, country: boolean = false): void {
    const dto: RoundOfQuestions | null = this.getCreationDto();
    const dtoDetail: RoundOfQuestionsDetail[] | null = this.getCreationDetailDto();
    if (dto && dtoDetail) {
      this.roundOfQuestionsService.createRoundOfQuestions(dto, dtoDetail).subscribe(
        (createdRoqResponse) => {
          if (system || country) { // send notifications
            this.roundOfQuestionsService.notifyRoundOfQuestions(createdRoqResponse.content, system, country).subscribe(() => {
              this.createEvent.emit();
              this.closeDialog();
            });
          } else {
            this.createEvent.emit();
            this.closeDialog();
          }
        },
        () => {
          this.closeDialog();
        }
      );
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private getCreationDto(): RoundOfQuestions {
    return {
      year: this.yearControl.value,
      name: this.nameControl.value,
      launched: this.launched,
      questionsType: this.typeControl.value?.toUpperCase()
    };
  }

  private getCreationDetailDto(): RoundOfQuestionsDetail[] {
    const detail: RoundOfQuestionsDetail[] = [];
    this.questionsSelectMap.forEach(questionsPerCategory => {
      for (let i = 1; i <= questionsPerCategory.size; i++) {
        for (const [key, value] of questionsPerCategory) {
          if (value === i) {
            detail.push({questions: key});
          }
        }
      }
    });
    return detail;
  }

  valueOrderAsc = (a: KeyValue<any, number>, b: KeyValue<any, number>): number => {
    return a.value - b.value;
  }

  filterCategories(categoryType: string): void {
    this.questionsService.getAllQuestionCategories('', {page: 0, size: 1000, sort: 'id', direction: 'asc'}, categoryType)
      .subscribe(
        data => {
          this.categories = data.content;
          this.categoriesChecked = [];
          this.categorySelectMap.clear();
          this.allCategoriesSelectedWithOrder = false;
          data.content.forEach(() => {
            this.categoriesChecked.push(false);
          });
        }
      );
  }

  cleanLevelFilter(): void {
    this.registrationLevel = '';
    this.levelControl.reset();
  }
}
